import React from "react";
import {Col, Row} from "antd";
import {MyBreadcrumb} from "../../components";


export const Curating = () => {
  return (
    <>
      <MyBreadcrumb title="Кураторство"/>

      <Row justify='center'>
        <Col span={20}>
          <Row>
            <Col span={24}>

            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}